import { Injectable } from '@angular/core';
import {Base} from 'primeng/base';
import {BaseService} from '../base.service';
import {environment} from '../../../../environments/environment';
import {IsTest} from '../../../pages/testing/components/interface/testing.interface';

@Injectable({
  providedIn: 'root',
})
export class TestsService extends  BaseService{

  public startTest(courseId:string){
    return this.http.post(`${environment.baseUrl}/service/webapi/v1/tests/courses/${courseId}/start`,null)
  }

  public isStartTest(){
    return this.http.get<IsTest>(`${environment.baseUrl}/service/webapi/v1/tests`)
  }

  public completedTest(courseId:string){
    return this.http.post(`${environment.baseUrl}/service/webapi/v1/tests/courses/${courseId}/complete`,null)
  }
}
